import { render } from "./AuthorsView.vue?vue&type=template&id=5003d274"
import script from "./AuthorsView.vue?vue&type=script&lang=ts"
export * from "./AuthorsView.vue?vue&type=script&lang=ts"
script.render = render

export default script